import { Shift } from '@umss/shared/data-access';
import { ShiftCard } from '../models/shift-card.model';
import { ShiftTypeEnum } from '@umss/shared/utils';
import dayjs from 'dayjs';

/**
 * Shared utility to map a Shift to ShiftCard for modal display
 * Used by both schedule and dashboard components
 */
export function mapShiftToShiftCard(shift: Shift): ShiftCard {
  const overtimeRate =
    (shift.shiftType === ShiftTypeEnum.Urgent
      ? (shift.rateInfo?.contractorUrgentFinalHourlyRate ??
        shift.rateInfo?.contractorUrgentHourlyRate)
      : null) ??
    shift.rateInfo?.contractorNormalFinalHourlyRate ??
    shift.rateInfo?.contractorNormalHourlyRate ??
    0;
  return {
    // ShiftNeed base properties
    id: shift.id,
    facilityId: shift.facilityId,
    facilityName: shift.facilityName,
    facilitySubtypeId: shift.facilitySubtypeId,
    facilitySubtypeName: shift.facilitySubtypeName,
    scopeOfPractice: shift.scopeOfPractice,
    scopeOfPracticeDisplay: shift.scopeOfPracticeDisplay || '',
    shiftType: shift.shiftType,
    shiftTypeDisplay: shift.shiftTypeDisplay,
    shiftDate: shift.shiftDate,
    startTime: shift.startTime,
    endTime: shift.endTime,
    numberOfPositions: 1,
    hourlyRate:
      shift.rateInfo?.contractorNormalFinalHourlyRate ??
      shift.rateInfo?.contractorNormalHourlyRate ??
      0,
    specialInstructions: shift.specialInstructions,
    status: shift.status,
    statusDisplay: shift.statusDisplay,
    expiresAt: undefined,
    postedByName: '',
    estimatedHours: shift.estimatedHours,
    estimatedPayment: shift.estimatedPayment,
    isUrgent:
      shift.shiftType === ShiftTypeEnum.Urgent ||
      shift.shiftTypeDisplay === 'Urgent',
    isExpired: false,
    createdAt: shift.createdAt || new Date().toISOString(),
    updatedAt: shift.updatedAt || new Date().toISOString(),

    // ShiftCard UI properties
    title: shift.facilityName || 'Facility',
    totalPay:
      shift.estimatedPayment ||
      (shift.rateInfo?.contractorNormalHourlyRate ?? 0) * shift.estimatedHours,
    overtimeRate: overtimeRate,
    date: dayjs(shift.shiftDate).format('dddd, MMMM D, YYYY'),
    duration: shift.estimatedHours,
    distance: shift.distanceMiles ? `${shift.distanceMiles} mi` : '',
    facilityAddress: shift.facilityFullAddress,
    scopesOfPractice: [
      shift.scopeOfPracticeDisplay || String(shift.scopeOfPractice)
    ],
    specialties: undefined,
    paymentSchedule: undefined,
    isRecurring: false,
    assignedNurse: undefined,
    actualStartTime: shift.actualStartTime,
    actualEndTime: shift.actualEndTime,
    breaks: shift.breaks,
    isEditable: shift.isEditable,
    timesheetStatus: shift.timesheetStatus,
    clockInWindowStart: shift.clockInWindowStart,
    clockInWindowEnd: shift.clockInWindowEnd,
    clockOutWindowStart: shift.clockOutWindowStart,
    clockOutWindowEnd: shift.clockOutWindowEnd,
    clockInNote: shift.clockInNote,
    clockOutNote: shift.clockOutNote
  };
}
